export const baseUrl = `https://move2x-stationfinderapi-prod.azurewebsites.net`;

// export const baseUrl = ``;
